export interface FiltroProcessoValidacaoClienteFornecedor {
  CCADASTRO: string;
  CCODIGO: string;
  CLOJA: string;
  CCGC: string;
  CNOMEREDUZ: string;
};

export const defaultFiltroProcessoValidacaoClienteFornecedor = (): FiltroProcessoValidacaoClienteFornecedor => {
  return {
    CCADASTRO: '1',
    CCODIGO: '',
    CLOJA: '',
    CCGC: '',
    CNOMEREDUZ: '',
  };
};

export interface ProcessoValidacaoClienteFornecedor {
  CCADASTRO: string;
  CCODIGO: string;
  CLOJA: string;
  CCGC: string;
  CNOMEREDUZ: string;
  NRECNO: number;
};

export interface ProcessoValidacaoClienteFornecedorLista {
  items: Array<ProcessoValidacaoClienteFornecedor>;
};

export const defaultProcessoValidacaoClienteFornecedor = (): ProcessoValidacaoClienteFornecedor => {
  return {
    CCADASTRO: '',
    CCODIGO: '',
    CLOJA: '',
    CCGC: '',
    CNOMEREDUZ: '',
    NRECNO: 0,
  };
};

export interface ProcessoValidacaoClienteFornecedorHistorico {
  CCALIAS: string;
  CZGXUSUARI: string;
  DZGXDATA: Date | undefined;
  CZGXHORA: string;
  CZGXTITULO: string;
  CZGXHISTOM: string;
};

export interface ProcessoValidacaoClienteFornecedorHistoricoLista {
  itemshist: Array<ProcessoValidacaoClienteFornecedorHistorico>;
};

export const defaultProcessoValidacaoClienteFornecedorHistorico = (): ProcessoValidacaoClienteFornecedorHistorico => {
  return {
    CCALIAS: '',
    CZGXUSUARI: '',
    DZGXDATA: undefined,
    CZGXHORA: '',
    CZGXTITULO: '',
    CZGXHISTOM: '',
  };
};
